// extracted by mini-css-extract-plugin
export default {"footer":"FooterContent_footer__i6pbd"};